<form (ngSubmit)="save()" [formGroup]="ruleForm">
	<div [alarisLoading]="loading$">
		<div class="edit-panel-header">
			<alaris-icon name="icon-add-contact"></alaris-icon>
			{{ (rule.id ? 'camara_rules.edit_rule' : 'camara_rules.create_rule') | translate }}
		</div>
		<div [alarisFade]="'vertical'" class="form-group panel-content">
			<alaris-select2
					[label]="'camara_rules.rule_type' | translate"
					formControlName="ruleType"
					[displayWith]="displayRuleType.bind(this)"
					[errors]="errors">
				@if (ruleTypes.length === 0) {
					<alaris-options2 [value]="null">{{ 'gl.none' | translate }}</alaris-options2>
				} @else {
					@for (type of ruleTypes; track type) {
						<alaris-options2 [value]="type.value">{{ type.name }}</alaris-options2>
					}
				}
			</alaris-select2>

			<alaris-text-area
					[expandable]="true"
					[placeholder]="'gl.textAreaHint' | translate"
					formControlName="prefixList"
					maxHeight="none"
					mode="tag"
					[errors]="errors">
				{{ 'camara_rules.prefix_list' | translate }}
			</alaris-text-area>

			<alaris-multi-select2
					[label]="'camara_rules.client' | translate"
					[optionsCount]="clients.length"
					[displayWith]="displayClient.bind(this)"
					formControlName="clientList"
					mode="tag"
					[showAllSelected]="true"
					[separator]="separator">
				@for (client of clients; track client.id) {
					<alaris-multi-options2 [value]="client.id">{{ client.name }}</alaris-multi-options2>
				}
			</alaris-multi-select2>

			<alaris-select2
					[label]="'camara_rules.source' | translate"
					formControlName="source"
					[errors]="errors">
				@if (sources.length === 0) {
					<alaris-options2 [value]="null">{{ 'gl.none' | translate }}</alaris-options2>
				} @else {
					@for (src of sources; track src.id) {
						<alaris-options2 [value]="src.name">{{ src.name }}</alaris-options2>
					}
				}
			</alaris-select2>
		</div>
		<div class="edit-panel-footer">
			<button [disabled]="ruleForm.invalid || (!ruleForm.dirty)" alaris-button bType="primary" type="submit">
				<alaris-icon class="in-primary" name="icon-success"></alaris-icon>
				{{ 'gl.submit' | translate }}
			</button>
			<button (click)="close()" alaris-button bType="outline" type="button">
				{{ 'actions.close' | translate }}
			</button>
		</div>
	</div>
</form>